import Layout1 from "./Layouts/Layout1/Layout1";

const routes = [

  { path: "/", component: Layout1 },
];

export default routes;
